import axios from 'axios';
import { setMaintenanceMode } from '@/maintenance/maintenanceManager';
import { emitUnauthorized } from '@/features/shared/services/authBus';
const taskManagerApi = axios.create({
    baseURL: import.meta.env.VITE_BACKEND_URL || 'https://app.utemaf.ma/api',
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});
export const isAuthEndpoint = (rawUrl) => {
    try {
        const url = new URL(rawUrl, taskManagerApi.defaults.baseURL);
        const { pathname } = url;
        return pathname.startsWith('/auth/login') ||
            pathname.startsWith('/auth/refresh') ||
            pathname.startsWith('/auth/me');
    }
    catch {
        return false;
    }
};
taskManagerApi.interceptors.response.use((response) => response, (error) => {
    if (axios.isCancel(error)) {
        return Promise.reject(error);
    }
    const status = error.response?.status;
    const url = error.config?.url ?? '';
    if (status === 401 && !isAuthEndpoint(url)) {
        emitUnauthorized();
        return Promise.reject(error);
    }
    if (!error.response || status >= 500) {
        setMaintenanceMode(true);
    }
    return Promise.reject(error);
});
export default taskManagerApi;
